import { Button, ButtonProps, Menu, MenuItem } from '@mui/material';
import React from 'react';

interface MenuButtonProps {
    label: string; // Use ButtonProps 'startIcon' to add icon
    ButtonProps?: Partial<ButtonProps>;
    children: React.ReactElement<typeof MenuItem>[];
}

export const MenuButton = (props: MenuButtonProps) => {
    const { label, ButtonProps, children } = props;
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);

    const openMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };

    const closeMenu = () => {
        setAnchorEl(null);
    };

    return (
        <>
            <Button
                id="basic-button"
                aria-controls={open ? 'basic-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={openMenu}
                onMouseOver={openMenu}
                {...ButtonProps}
            >
                {label}
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={closeMenu}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                    onMouseLeave: closeMenu,
                }}
            >
                {children}
            </Menu>
        </>
    )
}